export const APP_PRIMARY_COLOR = '#00ACA0';
export const APP_PRIMARY_FONT = 'Avenir';
